import ApplicationAdapter from './application';

export default class MessageLimitAdapter extends ApplicationAdapter {
  // there is always 1 set of limits for an environment, and all of its CRUD API calls are available under the same path:
  buildURL() {
    return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/message_limits`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'message-limit': MessageLimitAdapter;
  }
}
